<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
          <h4 class="card-title">{{ $t('sales_distribution_admin.sales_register') }}</h4>
      </template>
      <template v-slot:body>
        <b-overlay :show="unitLoad">
        <ValidationObserver ref="formAddProduct" v-slot="{ handleSubmit, reset }">
        <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset">
        <b-row>
            <b-col xs="12" sm="12" md="4">
              <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
              <b-form-group
                class="row"
                label-cols-sm="4"
                label-for="fiscal_year_id"
                slot-scope="{ valid, errors }"
              >
                <template v-slot:label>
                  {{$t('globalTrans.fiscal_year')}} <span class="text-danger">*</span>
                </template>
                <b-form-select
                  plain
                  v-model="search.fiscal_year_id"
                  :options="fiscalYearList"
                  id="fiscal_year_id"
                  :state="errors[0] ? false : (valid ? true : null)"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col xs="12" sm="12" md="4">
              <ValidationProvider name="Month" vid="month" rules="">
              <b-form-group
                class="row"
                label-cols-sm="4"
                label-for="month"
                slot-scope="{ valid, errors }"
              >
                <template v-slot:label>
                  {{$t('production_store.month')}}
                </template>
                <b-form-select
                  plain
                  v-model="search.month"
                  :options="monthList"
                  id="month"
                  :state="errors[0] ? false : (valid ? true : null)"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col lg="4" sm="12" md="4">
                <b-form-group
                    class="row"
                    label-cols-sm="6"
                    :label="$t('production_store.pro_category')"
                    label-for="category_id">
                    <b-form-select
                        plain
                        v-model="search.category_id"
                        :options="categoryList"
                        id="category_id">
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
           <b-col lg="4" sm="12">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="client_type"
                  >
                  <template v-slot:label>
                    {{ $t('sales_distribution_admin.demand_for') }}
                  </template>
                  <b-form-select
                      plain
                      v-model="search.client_type"
                      :options="getAgentTypeList"
                      id="client_type"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                  </b-form-select>
              </b-form-group>
          </b-col>
          <b-col lg="4" sm="12" v-if="search.client_type < 3">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="user_id "
                  >
                  <template v-slot:label>
                  {{$t('sales_distribution_admin.dealer_retailer')}}
                  </template>
                  <v-select name="user_id"
                  v-model="search.user_id"
                  label="text"
                  :reduce="item => item.value"
                  :options="agentNameList"
                  :placeholder="$t('globalTrans.select')"
                  :filter-by="myFilter"
                  />
              </b-form-group>
          </b-col>
          <b-col v-if="search.client_type === 2 && search.user_id === 'others'" lg="4" sm="12">
            <b-form-group
                class="row"
                label-cols-sm="4"
                label-for="name"
                >
                <template v-slot:label>
                    {{ $t('globalTrans.name') }}
                </template>
                <b-form-input
                    id="name"
                    v-model="search.name"
                ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
           <b-col lg="4" sm="12">
                  <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="from_date"
                  >
                  <template v-slot:label>
                  {{$t('sales_distribution_admin.from_date')}}
                  </template>
                  <b-form-input class="form-control"
                  v-model="search.from_date"
                  placeholder="Select From Date"
                  id="from_date"
                  ></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col lg="4" sm="12">
                  <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="to_date"
                  >
                  <template v-slot:label>
                  {{$t('sales_distribution_admin.to_date')}}
                  </template>
                  <b-form-input class="form-control"
                  v-model="search.to_date"
                  placeholder="Select To Date"
                  id="to_date"
                  ></b-form-input>
                  </b-form-group>
              </b-col>
            <b-col xs="12" sm="12" md="4">
                <b-button type="submit" variant="primary">{{ $t('globalTrans.search')}}</b-button>
            </b-col>
        </b-row>
        </b-form>
        </ValidationObserver>
        </b-overlay>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:body>
            <b-row v-if="loaded">
              <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
              </b-col>
              <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                <h3 class="text-bold">{{ $t('production_store.govt_info') }}</h3>
                <h4 class="text-center text-dark">{{ reportHeadData.orgName }}</h4>
                <span class="text-center text-dark">{{ reportHeadData.heading }}</span><br>
                <span class="text-center text-dark">{{ reportHeadData.address }}</span><br>
                <div class="titleDiv">
                  <span class="text-center text-dark reportTitle" style="font-weight:bold;">{{ $t('sales_distribution_admin.sales_register') }}</span><br>
                </div>
              </b-col>
              <b-col xs="12" sm="12" md="3" class="mt-4 text-right">
                <b-button-group>
                  <b-button @click="pdfExport" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                  <b-button variant="warning">
                    <export-excel
                      :data="excelData"
                      :title="headerValue"
                      worksheet="Report Sheet"
                      name="sales_register.xls">
                      {{ $t('globalTrans.export_excel') }}
                    </export-excel>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col xs="12" sm="12" md="12" class="mt-2 mb-1">
                <b-row>
                  <b-col xs="12" sm="12" md="8" class="text-left">
                   <span v-if="titleData.monthname !== ''" class="text-center text-dark">{{ ' ' + $t('sales_distribution_admin.month') + ' : ' }}{{ titleData.monthname }}</span><br>
                    <span v-if="search.client_type > 0" class="text-center text-dark">{{ ' ' + $t('sales_distribution_admin.demand_for') + ' : ' }}{{ getDealerOrSales(search.client_type) }}</span><br>
                    <span v-if="titleData.product_id !== ''" class="text-center text-dark">{{ ' ' + $t('production_store.product') + ' : ' }}{{ titleData.product_id }}</span>
                  </b-col>
                  <b-col xs="12" sm="12" md="4" class="text-right">
                    <span class="text-center text-dark">{{ titleData.year }}</span><br>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-overlay :show="loadingState">
              <b-row>
                  <b-col lg="12" xs="12" md="12">
                      <b-table bordered hover :items="report_data" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                        <template v-slot:cell(index)="data">
                          {{ $n(data.index + 1) }}
                        </template>
                        <template v-slot:cell(date)="data">
                          {{ data.item.receive_date | dateFormat }}
                        </template>
                        <template v-slot:cell(description)="data">
                           <span v-if="data.item.sales_center_id">
                            {{ getSalesCenterName(data.item.sales_center_id) }}
                           </span>
                           <span v-if="data.item.delivery_main?.del_or_retail_sc_id">
                                {{ getDealerRetailerName(data.item.delivery_main?.del_or_retail_sc_id) }}
                           </span>
                           <span v-else>
                                {{ currentLocale === 'bn' ? data.item.delivery_main?.name_bn : data.item.delivery_main?.name }}
                           </span>
                        </template>
                        <template v-slot:cell(bill_no)="data">
                          {{ 'Bill-' + data.item.delivery_order_id }}
                        </template>
                        <template v-slot:cell(challan_no)="data">
                          {{ 'CH-' + data.item.delivery_order_id }}
                        </template>
                        <template v-slot:cell(amount_number)="data">
                          {{ $n(data.item.total_amount) }}
                        </template>
                        <template v-slot:cell(collect_date)="data">
                          {{ getDates(data.item.payments) }}
                        </template>
                      </b-table>
                      <div class="mt-3 float-right" style="margin-right:100px;">
                            <strong>{{$t('globalTrans.total')}}:</strong> {{ $n(totalAmountSum()) }}
                      </div>
                  </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl, commonServiceBaseUrl } from '@/config/api_config'
import { fiscalYearData, salesRegisterReport } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import ExportPdf from './export-pdf_details'
import flatpickr from 'flatpickr'
import ReportHeading from '@/Utils/report-head'
import excel from 'vue-excel-export'
import { dateFormat } from '@/Utils/fliter'
import Vue from 'vue'
Vue.use(excel)
export default {
  mixins: [RouteBasedList],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      search: {
        fis_start_date: 0,
        fis_end_date: 0,
        client_type: 0,
        category_id: 0,
        user_id: '',
        month: 0,
        from_date: '',
        to_date: '',
        fiscal_year_id: 0
      },
      agentNameList: [],
      titleData: {
        client_type: 0,
        product_id: '',
        monthname: '',
        year: ''
      },
      registrationTypeList: [
          { value: 1, text_en: 'Dealer', text_bn: 'ডিলার' },
          { value: 2, text_en: 'Retailer/Others', text_bn: 'খুচরা/অন্যান্য' },
          { value: 4, text_en: 'Sales Center', text_bn: 'সেলস সেন্টার' }
      ],
      report_data: [],
      rows: [],
      nodata: true,
      loaded: false,
      unitLoad: false,
      reportHeadData: ''
    }
  },
  computed: {
     columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('globalTrans.date'), class: 'text-left' },
          { label: this.$t('globalTrans.description'), class: 'text-left' },
          { label: this.$t('sales_distribution_admin.bill_no'), class: 'text-left' },
          { label: this.$t('assitive_device_management.challan_no'), class: 'text-center' },
          { label: this.$t('sales_distribution_admin.amount_number'), class: 'text-center' },
          { label: this.$t('sales_distribution_admin.collect_date'), class: 'text-center' },
          { label: this.$t('production_store.comment'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'date' },
          { key: 'description' },
          { key: 'bill_no' },
          { key: 'challan_no' },
          { key: 'amount_number' },
          { key: 'collect_date' },
          { key: 'comment' }
        ]
      } else {
         keys = [
          { key: 'index' },
          { key: 'date' },
          { key: 'description' },
          { key: 'bill_no' },
          { key: 'challan_no' },
          { key: 'amount_number' },
          { key: 'collect_date' },
          { key: 'comment' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    headerValue: function () {
        const headerVal = []
        if (this.$i18n.locale === 'en') {
            headerVal[0] = this.reportHeadData.orgName
            headerVal[1] = this.reportHeadData.address
            headerVal[2] = this.$t('sales_center.sales_report')
            headerVal[3] = this.getHeadParam()
        } else {
            headerVal[0] = this.reportHeadData.orgName
            headerVal[1] = this.reportHeadData.address
            headerVal[2] = this.$t('sales_center.sales_report')
            headerVal[3] = this.getHeadParam()
        }
        return headerVal
    },
    excelData: function () {
        const listData = this.report_data
        var serial = 0
        const listContractor = listData.map(keyItem => {
          serial++
          let name = ''
          if (keyItem.sales_center_id) {
            name = this.getSalesCenterName(keyItem.sales_center_id)
          } else if (keyItem.delivery_main?.del_or_retail_sc_id) {
            name = this.getDealerRetailerName(keyItem.delivery_main?.del_or_retail_sc_id)
          } else {
            name = this.currentLocale === 'bn' ? keyItem.delivery_main?.name_bn : keyItem.delivery_main?.name
          }
            if (this.$i18n.locale === 'en') {
              return {
                  'SL No': serial,
                  'Date ': keyItem.receive_date,
                  'Details ': name,
                  'Bill No. ': 'Bill-' + keyItem.delivery_order_id,
                  'Challan No. ': 'CH-' + keyItem.delivery_order_id,
                  'Amount ': keyItem.total_amount,
                  'Callect Date ': this.getDates(keyItem.payments),
                  'Comment ': ''
              }
            } else {
              return {
                  'ক্রমিক সংখ্যা': this.$n(serial),
                  'তারিখ ': dateFormat(keyItem.receive_date),
                  'বিবরণ ': name,
                  'বিল নম্বর ': 'Bill-' + keyItem.delivery_order_id,
                  'চালান নম্বর ': 'CH-' + keyItem.delivery_order_id,
                  'টাকার পরিমাণ ': this.$n(keyItem.total_amount),
                  'আদায়ের তারিখ ': this.getDates(keyItem.payments),
                  'মন্তব্য ': ''
              }
            }
        })
        return listContractor
    },
    getAgentTypeList: function () {
      return this.registrationTypeList.map(item => {
          return Object.assign({}, item, { text: this.$i18n.locale === 'en' ? item.text_en : item.text_bn })
      })
    },
    fiscalYearList: function () {
      const objectData = this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0).sort((a, b) => b.value - a.value)
      return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
          } else {
              return { value: obj.value, text: obj.text_en }
          }
      })
    },
    categoryList: function () {
      return this.productCommonObj.productCategoryList.filter(item => item.status === 1)
    },
    monthList () {
      const objectData = this.$store.state.commonObj.monthList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    currentLocale () {
      return this.$i18n.locale
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  created () {
    this.headerName()
  },
  mounted () {
    flatpickr('#to_date', {})
    flatpickr('#from_date', {})
  },
  watch: {
    'search.fiscal_year_id': function (newVal, oldVal) {
      if (newVal !== 0) {
        this.unitLoad = true
        RestApi.getData(commonServiceBaseUrl, `${fiscalYearData}/${newVal}`).then(response => {
          this.search.fiscal_year_id = response.data.id
          this.search.fis_start_date = response.data.start_date
          this.search.fis_end_date = response.data.end_date
          this.titleData.year = this.getFiscalYear(response.data.id)
          this.report_data = []
          this.unitLoad = false
        })
      } else {
          this.search.fiscal_year_id = 0
          this.search.fis_start_date = ''
          this.search.fis_end_date = ''
          this.titleData.year = ''
          this.report_data = []
      }
    },
    'search.month': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.titleData.monthname = this.getMonthName(newVal)
      }
    },
    'search.client_type': function (newVal, oldVal) {
        if (newVal !== oldVal && newVal > 0) {
            this.getDealerRetailerListByType()
            if (newVal === 4) {
              this.search.name = ''
              this.search.user_id = ''
            }
        }
    },
     currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            }
            if (this.search.month) {
              this.monthList = this.getMonthName(this.search.month)
              this.titleData.monthname = this.getMonthName(this.search.month)
            }
            if (this.search.fiscal_year_id) {
              this.titleData.year = this.getFiscalYear(this.search.fiscal_year_id)
            }
            this.headerName()
     }
  },
  methods: {
    myFilter: (option, text, search) => {
        const temp = search.toLowerCase()
        return option.text_en.toLowerCase().indexOf(temp) > -1 ||
        option.text_bn.toLowerCase().indexOf(temp) > -1
    },
    getDealerOrSales (clientId) {
      const typeList = this.registrationTypeList.find(item => item.value === clientId)
      return this.$i18n.locale === 'bn' ? typeList.text_bn : typeList.text_en
    },
    totalAmountSum () {
      return this.report_data.reduce((acc, item) => acc + parseInt(item.total_amount), 0)
    },
    getDates (payments) {
        let dates = ''
        const coma = payments.length > 1 ? ', ' : ''
        payments.map(item => {
          dates += dateFormat(item.created_at) + coma
        })
        return dates
    },
    getHeadParam () {
        return (this.titleData.category_id ? this.$t('production_store.category') + ' : ' + this.titleData.category_id + ',' : '') +
        (this.titleData.sub_category_id ? this.$t('production_store.sub_category') + ' : ' + this.titleData.sub_category_id + ',' : '') +
        (this.titleData.product_id ? this.$t('production_store.product') + ' : ' + this.titleData.product_id + ',' : '') +
        (this.titleData.year ? this.titleData.year + ',' : '') +
        (this.titleData.monthname ? this.$t('sales_distribution_admin.month') + ' : ' + this.titleData.monthname : '')
    },
    getFiscalYear (Id) {
        const Year = this.$store.state.commonObj.fiscalYearList.find(item => item.value === Id)
        if (this.$i18n.locale === 'bn') {
            return this.$t('globalTrans.fiscal_year') + ': ' + Year.text_bn
        } else {
            return this.$t('globalTrans.fiscal_year') + ': ' + Year.text_en
        }
    },
    async headerName () {
       const headdata = await ReportHeading.getReportHead(productionServiceBaseUrl, 'configuration/report-heading/detail', 6)
       this.reportHeadData = headdata
       this.loaded = true
    },
    getMonthName (mId) {
      const monthId = parseInt(mId)
      const monthObj = this.monthList.find(item => item.value === monthId)
      return monthObj.text
    },
    getSalesCenterName (centerId) {
      const salesCenter = this.$store.state.commonObj.officeList.find(center => center.office_type_id === 2 && center.value === parseInt(centerId))
      if (salesCenter !== undefined) {
        return this.$i18n.locale === 'bn' ? salesCenter.text_bn : salesCenter.text
      } else {
        return ''
      }
    },
    getDealerRetailerName (delReId) {
      const dealerRetailer = this.productCommonObj.dealerRetailerList.find(item => item.value === parseInt(delReId))
      if (dealerRetailer !== undefined) {
        return this.$i18n.locale === 'bn' ? dealerRetailer?.text_bn : dealerRetailer?.text
      } else {
        return ''
      }
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, salesRegisterReport, params).then(response => {
          if (response.success) {
            this.report_data = response.data.slice().sort((a, b) => new Date(a.receive_date) - new Date(b.receive_date))
            if (this.report_data.length > 0) {
              this.nodata = false
            } else {
              this.nodata = true
            }
            // this.$store.dispatch('setList', response.data)
            // this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    pdfExport () {
      const reportTitle = this.$t('sales_distribution_admin.sales_register')
      ExportPdf.exportPdfDetails(productionServiceBaseUrl, 'configuration/report-heading/detail', 6, reportTitle, this.report_data, this, this.titleData)
    },
    getDealerRetailerListByType () {
        const typeId = this.search.client_type
        this.agentNameList = []
        this.agentNameList = this.productCommonObj.dealerRetailerList.filter(item => item.type === typeId).map(Obj => {
          return Object.assign({}, Obj,
            { value: Obj.value, text: this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn }
          )
        })
        if (typeId === 2) {
            this.agentNameList.push({ value: 'others', text: this.$t('child_admission_management.others'), text_bn: '', text_en: '' })
        }
    }
  }
}
</script>
